import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from './ui/Button';
import Card from './ui/Card';
import SecSeperator from './ui/SecSeperator';
import { $FIXME } from '../constants';
import { CAR_LIST_TYPE_ENUM, ICarListType } from '../pages/Home';
import { appendCurrency } from '../utils/Helper/jsHelpers';
import { NextChevron } from './icons/common.icons';
import { formatNumberCompact } from '../utils/Helper/PriceFormatter';

interface IPropType {
    title: string;
    subtitle: string;
    classes?: string;
    carData?: $FIXME;
    total?: number | null;
    type: ICarListType;
    maxPrice?: number;
    fuelType?: string;
    bodyType?: string | null;
    queryParams?: string;
    hideCountButton?: boolean;
}

const CarListByType = (props: IPropType) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    function getPathnameByType() {
        switch (props.type) {
            case CAR_LIST_TYPE_ENUM.newCars:
                return '?isNewCar=true';
            case CAR_LIST_TYPE_ENUM.electricCars:
                return '?isElectric=true';
            case CAR_LIST_TYPE_ENUM.importedCars:
                return '?imported=true';
            case CAR_LIST_TYPE_ENUM.cheapestCars:
                return `?maxPrice=${props?.maxPrice}`;
            case CAR_LIST_TYPE_ENUM.custom:
                return props.queryParams;
            default:
                return '';
        }
    }

    function handleCarTypeClick() {
        const searchParams = getPathnameByType();
        if (searchParams?.includes('maxPrice')) {
            const maxPriceParam = formatNumberCompact(props.maxPrice);
            navigate(
                `${t('/buy-cars-under', {
                    ns: 'routes'
                })}/${maxPriceParam}`
            );
        } else {
            navigate({
                pathname: t('/buy-cars', { ns: 'routes' }),
                search: searchParams
            });
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return props.carData.length ? (
        <div className="recently-added-container">
            <div className={`recently-added padding ${props.classes}`}>
                <SecSeperator />
                <div className="recently-header">
                    <h1 className="title">
                        {props.maxPrice
                            ? t(props.title, {
                                  X: appendCurrency(props?.maxPrice)
                              })
                            : t(props.title)}
                    </h1>
                    <p className="subtitle">
                        {props.maxPrice
                            ? t(props.subtitle, {
                                  X: appendCurrency(props.maxPrice)
                              })
                            : t(props.subtitle)}
                    </p>
                </div>

                <div className="recent-card__holder">
                    {props?.carData?.map((items: $FIXME, index: number) => {
                        return (
                            <div key={index} className="card-holder">
                                <Card item={items} newCarFlag={true} />
                            </div>
                        );
                    })}
                </div>
                {!props.hideCountButton && (
                    <>
                        <button
                            style={{ height: 0, background: 'transparent' }}
                            className="recently-added-link text-uppercase"
                            onClick={handleCarTypeClick}
                        >
                            {`${t('viewAllCars')}`}
                            <NextChevron className="position-absolute top--2px" />
                        </button>
                        <Button
                            class="mobile-btn text-uppercase"
                            text={`${t(
                                props.total === 1
                                    ? 'carAvailable'
                                    : 'carsAvailable'
                            )}`}
                            onClick={handleCarTypeClick}
                        />
                    </>
                )}
            </div>
        </div>
    ) : (
        <></>
    );
};

export default CarListByType;
